import { collectionEngineV1 } from '../apis.js';
const req = collectionEngineV1('/satisfactions');
export const add = (refId, satisfaction, comment) => req('POST', `/${refId}`, {
    body: {
        satisfaction,
        comment,
    },
});
export const get = (refId) => req('GET', `/${refId}`);
//# sourceMappingURL=satisfactions.js.map